import {
  CasDisplayField,
  CasRHFAutocompleteAsync,
  CasStackRow,
} from 'src/compass/shared/components';
import { IGeneralObjectType } from 'src/compass/site/util';

export default function OwnerForm({ row }: { row: IGeneralObjectType }) {
  return (
    <>
      <CasDisplayField label="Owner" value={row?.name} />
      <CasStackRow>
        <CasDisplayField label="Feedyard" value={row?.feedLotName} />
        <CasDisplayField label="Meta Source" value={row?.metaSource} />
      </CasStackRow>
      <CasDisplayField label="Current Entity" value={row?.entityName} />
      <CasRHFAutocompleteAsync
        url="Utilities/Entity/List"
        name="entityObj"
        label="Change to Entity"
      />
    </>
  );
}
